module.exports = __webpack_public_path__ + "static/media/lr.03762e2d.svg";